<template>
  <div>
    <div class="absolute inset-0 grid h-full grid-cols-5 text-sm text-white 2xl:grid-cols-4">
      <div class="relative col-span-3 2xl:col-span-3 disclaimer">
        <div class="absolute inset-0 overflow-hidden">
          <img src="images/GARDEN_FINAL.jpg" srcset="images/GARDEN_FINAL.jpg 1x, images/GARDEN_FINAL@2x.jpg 2x" class="object-cover object-center w-full h-full" alt="">
        </div>
      </div>
      <div class="relative flex flex-col col-span-2 px-12 py-20 pb-4 xl:px-16 xl:py-24 2xl:col-span-1">
        <div class="absolute inset-0">
          <img src="images/1420602380-huge-half-v.jpg" srcset="images/1420602380-huge-half-v.jpg 1x, images/1420602380-huge-half-v@2x.jpg 2x" class="object-cover object-left-top w-full h-full" alt="">
          <div class="absolute inset-x-0 bottom-0">
            <img src="images/pattern-02.png" srcset="images/pattern-02.png 1x, images/pattern-02@2x.png 2x" class="object-cover w-full h-full" alt="">
          </div>
        </div>
        <h1 class="relative mb-8 text-3xl font-bold uppercase xl:mb-16 2xl:mb-32">
          Project Information
        </h1>

        <swiper :space-between="100" :pagination="{ clickable: true }" loop :autoplay="{ delay: 30000 }" class="flex-1 w-full px-2 -mx-2 leading-normal">
          <swiper-slide class="">
            <div class="grid grid-cols-2 table-info">
              <span class="font-bold">ชื่อโครงการ</span>
              <span>เอสเซ็นท์ หาดใหญ่<br>ESCENT HATYAI</span>

              <span class="font-bold">เจ้าของโครงการ</span>
              <span>บริษัท ซีพีเอ็น เรซซิเด้นซ์ จํากัด</span>

              <span class="font-bold">ที่ตั้งโครงการ</span>
              <span>ตำบลหาดใหญ่, อำเภอหาดใหญ่, จังหวัดสงขลา 90110</span>

              <span class="font-bold">พื้นที่โครงการ</span>
              <span>3 – 0 – 34 ไร่</span>

              <span class="font-bold">ลักษณะโครงการ</span>
              <ul>
                <li>
                  คอนโด High-rise สูง 36 ชั้น 1 อาคาร
                </li>
                <li>
                  ห้องพัก 665 ยูนิต และ ร้านค้า 1 ยูนิต
                </li>
                <li>
                  รวม 666 ยูนิต
                </li>
                <li>
                  อาคารจอดรถ 6 ชั้น
                </li>
              </ul>

              <span class="font-bold">ที่จอดรถ</span>
              <ul>
                <li>
                  ประมาณ 238 ช่องจอด
                </li>
                <li>
                  คิดเป็น 35% (ไม่รวมซ้อนคัน)
                </li>
              </ul>
            </div>
          </swiper-slide>

          <swiper-slide class="space-y-4">
            <div class="font-bold">
              รายละเอียดห้องชุด
            </div>
            <div>
              <div class="flex justify-between font-bold">
                <span>ประเภทห้อง</span>
                <span>พื้นที่ใช้สอยประมาณ</span>
              </div>
              <div class="flex justify-between">
                <span>แบบ 1 Bedroom</span>
                <span>27.5 - 32 ตร.ม.</span>
              </div>
              <div class="flex justify-between">
                <span>แบบ 2 Bedrooms</span>
                <span>42 - 52 ตร.ม.</span>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide class="space-y-2 xl:space-y-4">
            <h2 class="font-bold">
              สิ่งอํานวยความสะดวก
            </h2>
            <ul class="mx-4 list-disc">
              <li>
                Rooftop View 360 องศา ชมวิวเมืองได้บนชั้นสูงสุด
              </li>
              <li>
                Panoramic Sky Fitness ชั้น 36
              </li>
              <li>
                Sky Pool ขนาด 25x4 ม. ระบบเกลือ แยกโซนเด็ก ผู้ใหญ่ และจากุชชี่ พร้อมด้วยห้องซาวน่า ชั้น 35
              </li>
              <li>
                Sky Park View ชั้น 35 แยกสัดส่วนการใช้งานทั้ง Active Zone และ Passive Zone ให้ความสงบ เหมาะกับการพักผ่อน
              </li>
              <li>
                Private Garden สวนส่วนกลาง ชั้น 6 เพิ่มพื้นที่สีเขียว ให้ความร่มรื่นเป็นส่วนตัว
              </li>
              <li>
                Multi Purpose Room บริเวณชั้น 1
              </li>
              <li>
                Laundry Cafe’ พื้นที่พักผ่อนระหว่างรอซักผ้า
              </li>
              <li>
                Jogging Track บริเวณด้านข้างอาคาร ชั้น 1
              </li>
            </ul>
          </swiper-slide>

          <swiper-slide class="space-y-2 xl:space-y-4">
            <h2 class="font-bold">
              ระบบรักษาความปลอดภัย
            </h2>
            <ul class="mx-4 list-disc">
              <li>
                Access Control เพิ่มความปลอดภัยเข้าออกโครงการ และส่วนกลาง
              </li>
              <li>
                Face Scan ครอบคลุมพื้นที่เข้าออกโครงการ
              </li>
              <li>
                Pass Card สำหรับรถยนต์ตั้งแต่ทางเข้าด้านหน้า
              </li>
              <li>
                กล้อง CCTV  และระบบรักษาความปลอดภัย Security Guards ตลอด 24 ชั่วโมง
              </li>
              <li>
                VMS Security ระบบนัดหมายเข้าพบลูกบ้าน ให้คุณมั่นใจได้ถึงความปลอดภัยสูงสุด
              </li>
            </ul>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([
  Pagination,
  Autoplay,
  Lazy,
])

export default {
  name: 'ProjectDetails',
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>

<style lang="postcss" scoped>
.table-info {
  grid-template-columns: minmax(112px, 1fr) auto;

  & > *:nth-child(even) {
    @apply mb-0;
  }

  & > *:last-child {
    @apply mb-0;
  }
}
</style>
